import { render, staticRenderFns } from "./SeriesCategoriesListingContainer.vue?vue&type=template&id=4f90ca9a"
import script from "./SeriesCategoriesListingContainer.vue?vue&type=script&lang=js"
export * from "./SeriesCategoriesListingContainer.vue?vue&type=script&lang=js"
import style0 from "./SeriesCategoriesListingContainer.vue?vue&type=style&index=0&id=4f90ca9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports